import { connect } from 'react-redux';
//children
import SelectEntity from './SelectEntity';
//action creator
import {
  createCase,
  createEntity,
  updateEntityWithCaseId,
  deleteEntity,
  deleteCase
} from '../actions/actionCreator';

import { clearInFlightCasesStateForAllEntites } from '../../ViewEntityProfile/actions/actionCreator';
import { setDarkTitleBarContent, hideDarkTitleBarActionModal } from '../../layouts/actions/actionCreator';
import { getDarkTitleBarFlag } from '../../CaseBody/actions/actionCreator';
import { resetStore } from '../../../actions/actionCreator';

const mapStateToProps = state => {
  return {
    cases: state.cases,
    entities: state.entities,
    inFlightCasesState: state.inFlightCasesState,
    _showDarkTitleBarActionModal: state.darkTitleBar.showActionModal,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createCase: _case => {
      dispatch(createCase(_case))
    },
    createEntity: _entity => {
      dispatch(createEntity(_entity))
    },
    updateEntityWithCaseId: (entityId, caseId) => {
      dispatch(updateEntityWithCaseId(entityId, caseId))
    },
    deleteEntity: _entity => {
      dispatch(deleteEntity(_entity))
    },
    deleteCase: caseId => {
      dispatch(deleteCase(caseId))
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    hideDarkTitleBarActionModal: () => {
      dispatch(hideDarkTitleBarActionModal())
    },
    resetStore: (lang) => {
      dispatch(resetStore(lang))
    },
    getDarkTitleBarFlag: flag => {
      dispatch(getDarkTitleBarFlag(flag));
    },
    clearInFlightCasesStateForAllEntites: () => {
      dispatch(clearInFlightCasesStateForAllEntites())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectEntity);



// WEBPACK FOOTER //
// ./src/components/createAcase/SelectEntity/index.js